import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const ZoomFactorButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-search-plus fa-fw"
        clickHandler={clickHandler}
        title={t('options.zoom-title')}
        id="zoomOptionButton"
        a11yAttributes={a11yAttributes}
    />);
};

ZoomFactorButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default ZoomFactorButton;
